import React from 'react';
import { default as WidgetBox, Props } from './WidgetBox';
import {
  default as WidgetBoxContainer,
  ConnectedKeys,
} from './WidgetBox.container';

export default WidgetBoxContainer(WidgetBox) as React.ComponentClass<
  Without<Props, ConnectedKeys>
>;
export type Props = Props;
